// @flow
import React from 'react';
import { FlexRow } from 'styles/Layout';
import styled from 'styled-components';

const Wrapper = styled(FlexRow)`
  height: 40px;
  min-height: 40px;
  width: 100%;
  background-color: #3c3a3a;
`;

const Text = styled.span`
  min-height: 15px;
  color: #cfcfcf;
  font-size: 13px;
  line-height: 15px;
`;

export default function Footer() {
  return (
    <Wrapper justifyContent="center" alignItems="center">
      <Text>
        Todos los derechos estan reservados a Homie {new Date().getFullYear()}
      </Text>
    </Wrapper>
  );
}
